import { useState } from "react";
import { useLocation } from "react-router-dom";
import control from "../../assets/controls-alt.png";
import { highToLow, lowToHigh } from "../../utils/sorting/sorting";

const SortBy = ({ margin, setFilter, product }) => {
  const [showSort, setShowSort] = useState(false);

  const location = useLocation();
  return (
    <div
      className={`relative ${
        location.pathname === "/communities" ? "w-full" : "w-36"
      } flex justify-end`}
    >
      <div className="">
        <div
          className={`flex flex-col justify-end cursor-pointer ${margin}`}
          onClick={() => setShowSort(!showSort)}
        >
          <div className="flex gap-2 items-center">
            <img src={control} alt="control" />
            <div className="font-bold text-base">Sort by</div>
          </div>
        </div>
        {showSort && (
          <div className={`w-full flex justify-end`}>
            <div
              className={`absolute float-right ${
                location.pathname === "/communities" ? "top-10" : "top-6"
              } right-0 ${
                location.pathname === "/communities" ? "w-36" : "w-full"
              } bg-white rounded-xl shadow-xl text-right text-sm`}
            >
              <button
                className="p-2 mt-1"
                onClick={() => setFilter(lowToHigh(product))}
              >
                Low to high prices
              </button>
              <button
                className="p-2 mt-1"
                onClick={() => setFilter(highToLow(product))}
              >
                High to low prices
              </button>
              <button className="p-2 mt-1">Seller's rating</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SortBy;
